import React, { Component } from 'react';
import { connect } from 'react-redux';

import { BasketDetailsModel, StockTypes, ProductTypes } from 'models/Basket';
import { PlacedOrderModel } from 'models';
import { AppState } from 'store';
import { stringComparer } from 'helpers';
import { ReadonlyItem, ReadonlyItemBundle } from 'components';

interface OwnProps {
    useOrderEntries?: boolean;
}

interface StateProps {
    basket: BasketDetailsModel | null;
    order: PlacedOrderModel | null;
}

class ReadonlyItemList extends Component<OwnProps & StateProps> {

    render(): JSX.Element {
        let entries;

        if (this.props.useOrderEntries) {
            entries = this.props.order?.entries;
        } else {
            entries = this.props.basket?.entries;
        }

        entries = entries?.sort((a, b) => stringComparer(a.stockType, b.stockType));

        return (
            <div className='checkout-items-list'>
                {
                    entries?.map(checkoutItem => {
                        if (checkoutItem.product?.type === ProductTypes.Sofaglide) {
                            return null;
                        }

                        return (
                            checkoutItem.hasStockType(StockTypes.ExDisplay)
                                ? <div className='checkout-item-bundle__wrapper' key={checkoutItem.product.code}>
                                    <ReadonlyItemBundle
                                        checkoutItem={checkoutItem} />
                                </div>
                                : <React.Fragment key={checkoutItem.product.code}>
                                    <ReadonlyItem
                                        checkoutItem={checkoutItem} />
                                </React.Fragment>
                        );
                    })
                }
            </div>
        );
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        basket: state.basketState.basket,
        order: state.checkoutState.order
    };
}

export default connect(mapStateToProps)(ReadonlyItemList);